module.exports = __webpack_public_path__ + "img/water-hut.b58de528.jpg";